<template>
  <div>
    <CRow class="mt-4 content-fade-in mt-3p5">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CRow>
              <CCol sm="6" md="6" xl="6">
                <div class="form-input-wrapper">
                  <label class="form-label">{{ selectedFiles.options.label }}</label>
                  <div class="custom-file"
                       :class="selectedFiles.data.validator.isValid == false ? 'input-valid-error' : ''">
                    <input type="file" class="custom-file-input" ref="file"
                           :accept="selectedFiles.options.accept" @change="selectFile($event)">
                    <label class="custom-file-label">{{ selectedFiles.data.model.fileName }}
                      <i v-if="selectedFiles.data.loading" class="fa fa-spinner fa-spin"
                         style="position: absolute; right: 100px;font-size: 20px;top: 8px;"></i>
                    </label>
                  </div>
                  <div class="valid-error"
                       v-show="!(selectedFiles.data.validator ? selectedFiles.data.validator.isValid : true)">
                    {{ selectedFiles.data.validator ? selectedFiles.data.validator.errorMessage : "" }}
                  </div>
                </div>
              </CCol>
              <CCol sm="6" md="12" xl="12" class="mt-4">
                <audio :src="url" controls ref="audio"></audio>
              </CCol>
            </CRow>
            <CRow>
              <CCol class="mt-3">
                <CButton color="primary" class="mr-2" @click="submitData()" :disabled="isDisableSubmit"><i
                  class="fa fa-check"></i> Đồng ý
                </CButton>
                <CButton color="secondary" @click="resetData()"><i class="fa fa-eraser"></i> Làm mới</CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseFormLoading from "@/views/base/BaseFormLoading";

export default {
  name: 'UserManual',
  components: {BaseFormLoading},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    return {
      loading: {value: false},
      selectedFiles: {
        options: {
          label: 'Chọn tệp',
          accept: '.mp3 , .wav, .aac'
        },
        data: {
          loading: false,
          model: {
            fileName: 'Chọn tệp',
            content: '',
            size: '',
            type: ''
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              this.isValid = that.validateFile();
              return this.isValid;
            }
          }
        }
      },
      isDisableSubmit: false,
      url: ''
    }
  },
  created() {
  },
  mounted() {
    this.getFileCheckSoundSpeaker();
  },
  methods: {
    async downloadFile(url) {
      this.loading.value = true;
      const imgUrl = await this.$helper.blobFileByUrl(url);
      this.loading.value = false;
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.href = imgUrl;
      a.download = url.substring(url.lastIndexOf("/") + 1, url.length);
      a.click();
    },
    selectFile() {
      let that = this;
      let reader = new FileReader();
      let file = this.$refs.file.files[0];
      if (file) {
        reader.readAsDataURL(file);

        reader.onload = function () {
          that.isDisableSubmit = false;
          that.validateFile(file.type, file.size);
          that.selectedFiles.data.model.size = file.size;
          that.selectedFiles.data.model.fileName = file.name;
          that.selectedFiles.data.model.type = file.type;
          that.selectedFiles.data.model.content = reader.result;
        }
        reader.onloadend = function () {
          that.selectedFiles.data.loading = false;
        }
      }
    },
    validateFile(type, size) {
      let isValid = true;
      if ((type && type != undefined) && (size && size != undefined)) {
        isValid = this.validateFileType(type);
      } else {
        if (this.selectedFiles.data.model.type && this.selectedFiles.data.model.size) {
          isValid = this.validateFileType(this.selectedFiles.data.model.type);
        } else {
          if (this.selectedFiles.data.model.type === '') {
            this.selectedFiles.data.validator.isValid = false;
            this.selectedFiles.data.validator.errorMessage = "Hướng dẫn sử dụng không để trống";
            isValid = false;
          }
        }
      }
      return isValid;
    },
    validateFileType(type) {
      let isValid = true;
      if (type === "audio/mpeg" || type === "audio/wav" || "audio/vnd.dlna.adts") {
        this.selectedFiles.data.validator.isValid = true;
        this.selectedFiles.data.validator.errorMessage = "";
      } else {
        this.selectedFiles.data.validator.isValid = false;
        this.selectedFiles.data.validator.errorMessage = "Sai định dạng bản tin";
        isValid = false;
      }
      return isValid;
    },
    resetData() {
      this.selectedFiles.data.loading = false;
      this.selectedFiles.data.validator.isValid = true;
      this.selectedFiles.data.validator.errorMessage = '';
      this.selectedFiles.data.model = {
        fileName: 'Chọn tệp',
        content: '',
        size: '',
        type: ''
      }
      // this.isDisableSubmit = true;
    },
    submitData() {
      let isValid = false;
      isValid = this.validateFile(this.selectedFiles.data.model.type, this.selectedFiles.data.model.size);
      if (!isValid) {
        return;
      }
      let that = this;
      that.loading.value = true;
      let formData = new FormData();
      formData.append("file", that.$refs.file.files[0]);

      that.$helper.loadDataSource({
        url: "/common/uploadSoundCheckSpeaker",
        dataSubmit: function () {
          return formData;
        },
        isMultiPartFormData: true,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Upload hướng dẫn sử dụng thành công"});
          }
          that.resetData();
          that.loading.value = false;
          that.getFileCheckSoundSpeaker();
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false;
        }
      });
    },
    getFileCheckSoundSpeaker() {
      let that = this;
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/common/getFileCheckSoundSpeaker",
        successCallback: async function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.loading.value = false;
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            const blob = await that.$helper.fetchToBlob(response.data.data)
            let url = URL.createObjectURL(blob)
            that.url = url;
            that.$refs.audio.load();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  computed: {},
  watch: {}
}
</script>

<style scoped>

</style>
